import { TableModel } from '../TableModel';

export class BikesListModel {
  constructor() {
    this.loading = false;
    this.pagedData = new TableModel(
      { pageNumber: 1, pageSize: 1000 },
      [{ id: 'tenant', value: 'asc' }, { id: 'bikeNumber', value: 'asc' }],
      []);
  }
}

export const InternalUseOnlyOptions = {
  true: { value: 'true', name: 'TAK' },
  false: { value: 'false', name: 'NIE' },
};

export const SponsoredOptions = {
  true: { value: 'true', name: 'TAK' },
  false: { value: 'false', name: 'NIE' },
};

export const BikeTechnicalStatusOptions = {
  functional: { value: 'functional', name: 'Sprawny', color: '#2e7d32' },
  damaged: { value: 'damaged', name: 'Uszkodzony', color: '#ed6c02' },
  missing: { value: 'missing', name: 'Zaginiony', color: '#d32f2f' },
};

export const ShackleStateOptions = {
  closed: { value: 'closed', name: '0' },
  opened: { value: 'opened', name: '1' },
};

export const LockStateOptions = {
  closed: { value: 'closed', name: '0' },
  opened: { value: 'opened', name: '1' },
};
